export default {
  title: 'BBT 用途',
  tokenName: 'Bubble Tea Coin (BBT)',
  description: 'BBT 是由 PUF平台發行於 World Chain 的 Meme Coin，也是 Bubble Game 誕生的起點。\n\n最初只是一枚小小的 Meme Coin，卻讓我們走進 World Chain 的世界，認識來自不同地方的朋友，也成為創作 Bubble Game 的第一個靈感。從 BBT 開始，Bubble Game 一步一步成形，之後更誕生了真正屬於遊戲世界的代幣 BBG。\n\n為了讓這段起源一直延續，我們建立了 BBT 熔爐：玩家可以燃燒 BBT，將這枚陪伴 Bubble Game 誕生的啟蒙代幣，轉化成 BBG，成為新遊戲經濟的一部分。',
  closing: 'BBT 不只是 Bubble Game 裡的一項資產。\n它是這個世界的第一塊基石，也是所有故事開始的地方。',
  bbgTokenName: 'Bubble Game Token - BBG',
  bbgDescription: 'BBG 是 Bubble Game 生態系統的原生功能型代幣，隨遊戲世界的建立而誕生，用於支撐整體遊戲經濟運行。 玩家可透過每日任務，挖礦及戰鬥獲得BBG。BBG 的生成機制延續 BBT 的起源敘事，泡泡熔爐銷毀 BBT 以鑄造 BBG，使最初作為 Meme Coin 的 BBT 轉化為具備實際用途的遊戲內資產。',
  enterBubbleGame: '進入泡泡遊戲',
  bubbleGameDeepLinkNotConfigured: 'Bubble Game 連結尚未設定。',
  openBbgInfo: '開啟 BBG 說明',
  closeBbg: '關閉 BBG 說明',
  furnaceTitle: 'Bubble Game 泡泡熔爐',
  furnaceDescription: '在 Bubble Game 熔爐內將 BBT 轉化為 Fuel。',
  furnaceVideoLinkLabel: '開啟 Bubble Game 泡泡熔爐',
  deepLinkNotConfigured: 'World App 熔爐連結尚未設定。',
  buyBbt: '購買BBT',
  openInfo: '開啟 BBT 說明',
  close: '關閉 BBT 說明',
} as const;
